import React from 'react'

import Content from '../@react-fefmwk/theme-structure/modules/Content'
import CardLead from '../modules/CardLead'

class CardLeadPage extends React.Component {
    render() {
        const title = this.props.route.title
        const id_entity = this.props.route.computedMatch.params.id

        return <Content title={title}>
            <CardLead id_entity={id_entity} />
        </Content>
    }
}

export default CardLeadPage